export default __webpack_public_path__ + "static/feedback-bc6596e20e594519b8477f369e2a1b4c.jpg";